module.exports = __webpack_public_path__ + "img/product_revenue_icon.3aefee1b.svg";